module.exports = __webpack_public_path__ + "static/bienvenido-ccd9d5502ef9d1ef0eaa2ccc03ad45f2.png";